function initResponsiveMediaSamplePositioning() {
    const mobileMediaQuery = window.matchMedia('(max-width: 650px)')

    document.querySelectorAll('.title-detail-v2-component .hero').forEach((heroElement) => {
        const mediaItems = heroElement.querySelector('.title-cover .media-items')
        const mediaSamples = mediaItems && mediaItems.querySelector('.media-samples')
        const description = heroElement.querySelector('.title-data .description')

        if (!mediaItems || !mediaSamples || !description) {
            return
        }

        const originalPosition = document.createComment('media-samples-position')
        mediaItems.insertBefore(originalPosition, mediaSamples)

        const updatePosition = () => {
            if (mobileMediaQuery.matches) {
                description.parentNode.insertBefore(mediaSamples, description.nextSibling)
            } else {
                originalPosition.parentNode.insertBefore(mediaSamples, originalPosition.nextSibling)
            }
        }

        updatePosition()

        if (mobileMediaQuery.addEventListener) {
            mobileMediaQuery.addEventListener('change', updatePosition)
        } else {
            mobileMediaQuery.addListener(updatePosition)
        }
    })
}

export default initResponsiveMediaSamplePositioning
